import { render, staticRenderFns } from "./TraxUiVerticalTabs.vue?vue&type=template&id=15c5d008"
import script from "./TraxUiVerticalTabs.vue?vue&type=script&lang=js"
export * from "./TraxUiVerticalTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports